import React from 'react'
import ReactDOM from 'react-dom/client'
import './scss/index.scss'

import reportWebVitals from './reportWebVitals'
import { initializeDataLayer } from './utils/gtm'
import { store } from './redux/store'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import AppContent from './app'

initializeDataLayer()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
	<>
		<Provider store={store}>
			<BrowserRouter>
				<AppContent />
			</BrowserRouter>
		</Provider>
	</>
)

reportWebVitals()
